"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFortumAsAnInvestment = function IconFortumAsAnInvestment(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.028 5.283A3 3 0 0 1 32.22 7.09l.052.187.44 1.84-1.946.466-.44-1.841a1.006 1.006 0 0 0-1.278-.724l-.108.044-14.47 7.72-.942-1.764zm6.874 6.028a3 3 0 0 0-2.562-.607l-8.362 2.178.504 1.936 8.33-2.17.118-.018A1.006 1.006 0 0 1 34 13.655V15h2v-1.32l-.002-.192a3 3 0 0 0-1.096-2.177m5.093 9.472A5 5 0 0 0 35 16H12l-.217.005A5 5 0 0 0 7 21v17l.005.217A5 5 0 0 0 12 43h23l.217-.005A5 5 0 0 0 40 38v-3h2V23h-2v-2zM31 35h7v3l-.005.176A3 3 0 0 1 35 41H12l-.176-.005A3 3 0 0 1 9 38v-1.03h9v-1H9v-2h5v-1H9V21l.005-.176A3 3 0 0 1 12 18h23l.176.005A3 3 0 0 1 38 21v2h-7a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3m0-10h9v7.999L31 33a1 1 0 0 1-1-1v-6l.007-.117A1 1 0 0 1 31 25m5 3.97a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })));
};

export { IconFortumAsAnInvestment, IconFortumAsAnInvestment as default };
